export default {
    body: {
      cmpt: {
        type: 'CCabinetTemplateInfo'
      }
    }
  }
  